import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';

export default function YandexMap({ width, height, center, zoom = 15 }) {
  return (
    <YMaps>
      <Map
        defaultState={{ center: center || [55.75, 37.57], zoom: zoom }}
        state={center ? { center, zoom } : undefined}
        width={width ? `${width}` : '100%'}
        height={height ? `${height}` : '100%'}
      >
        {center && <Placemark geometry={center} />}
      </Map>
    </YMaps>
  );
}